<template>
<div class="row">
<div class="col text-right">
  <span v-if="user"><payout-confirmation :user="user" v-if="newBalance > 0" @update-balance="updateBalance"></payout-confirmation></span>
  <span :class="user.balance > 0 ? 'debit' : null">{{formattedPrice(newBalance)}}</span>
</div>
</div>
</template>

<script>

export default {
  props: ['balance','user'],

  data() {
    return {
      balance_class: 'owing',
      newBalance: 0,
    };
  },

  created() {
    this.updateBalance(this.balance);
  },

  methods: {
    updateBalance(balance) {
      this.newBalance = balance;
      this.user.balance = balance;
      this.$emit('balance-updated');
    },

  },
};
</script> 

<style scoped>
.balance{
  font-weight: 500;
  color: #ffffff;
  border-radius: 5px;
  border: none !important;
}
.owing { background-color: #e55171; }
.paid { background-color: #5ca26e; }

</style>